<div id="dialog_container" class="small-dialog-container">
  <div id="upper_band" class="upper-band upper-band-color"></div>
  <div id="middle_band" class="center-band center">
    <img
      id="error_icon"
      src="/assets/images/error-icon.svg"
      alt="Success"
      width="100"
      class="image-icon" />
    <span class="text-content">
      <div id="title" class="title">{{ title() }}</div>
      <div id="message">{{ message() }}</div>
    </span>
  </div>
  <hr class="custom-hr" />
  <div id="lower_band" class="lower-band">
    <button mat-button id="close_button" class="blue-button common-button" (click)="dialog.close()">
      Close
    </button>
  </div>
</div>
